import { Dispatch, SetStateAction } from 'react';
import Iframe from 'react-iframe';
import MyModal from '../../../../components/Modal';
import { useAppContext } from '../../../../contexts/auth';
import { MappedPassengerType } from '../types';

interface PassengerRoutingInterface {
  passengerInfo: MappedPassengerType;
  routingModalShow: boolean;
  setRoutingModalShow: Dispatch<SetStateAction<boolean>>;
}

export default function PassengerRoutingModal({ passengerInfo, routingModalShow, setRoutingModalShow }: PassengerRoutingInterface) {
  const { selectedCompany } = useAppContext();
  return (
    <MyModal
      show={routingModalShow}
      title={`Roteirização do passageiro ${passengerInfo.name}`}
      modalBody={(
        <Iframe
          url={`${process.env.REACT_APP_MYLINK_BASE_URL}?codEmpresa=${selectedCompany.value}&codConsulta=${passengerInfo.consultCode}&codFuncionario=${passengerInfo.employeeCode}`}
          width="100%"
          height={`${window.innerHeight}`}
          position="relative"
        />
      )}
      closeButtonLabel="Fechar"
      onClose={() => {
        setRoutingModalShow(false);
      }}
      type="info"
      size='xl'
    />
  );
}
